'use strict';

/**
 * Used to search and display badge elements.
 * @param {jQuery} dataElement - product data
 * @param {string} flagClass - class used in badge element
 */
function searchAndShowElement(dataElement, flagClass) {
    dataElement.closest('.js-product-tile').find(flagClass).removeClass('bbw-hide');
}

/**
 * It takes a color and an opacity percentage and returns the RGBA value.
 * @param {string} hexCode - color in hexadecimal format
 * @param {number} opacity - opacity number
 */
function convertHexToRGBA(hexCode, opacity = 1) {
    let hex = hexCode.replace('#', '');

    if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    /* Backward compatibility for whole number based opacity values. */
    if (opacity > 1 && opacity <= 100) {
        opacity = opacity / 100;
    }

    return `rgba(${r},${g},${b},${opacity})`;
}

/**
 * Manages the badges of each product present in the tiles.
 */
function manageTileBadges() {
    $('.js-product-tile .tile-uncached-data').each(function () {
        var $uncachedData = $(this);
        var hasLowInventory = $uncachedData.data('is-low-inventory');
        var isSoldOut = $uncachedData.data('is-soldout');
        var hasStandardBadge = $uncachedData.data('display-badge');
        var $inventoryLabelData = $uncachedData.closest('.js-product-tile').find('.js-product-low-inventory-label');
        var badgeBgColor = $inventoryLabelData.data('badge-bg-color');
        var badgeColor = $inventoryLabelData.data('badge-color');
        var badgeOpacity = $inventoryLabelData.data('badge-opacity');

        if (badgeOpacity && badgeOpacity !== '') {
            badgeBgColor = convertHexToRGBA(badgeBgColor, badgeOpacity / 100);
        }

        if (badgeBgColor && badgeBgColor !== '') {
            $inventoryLabelData.css('background-color', badgeBgColor);
        }

        if (badgeColor && badgeColor !== '') {
            $inventoryLabelData.css('color', badgeColor);
        }

        if (isSoldOut) {
            searchAndShowElement($uncachedData, '.product-sold-out-label');
            $uncachedData.closest('.js-product-tile').find('.add-to-cart').attr('disabled', true);
        } else {
            if (hasLowInventory) {
                searchAndShowElement($uncachedData, '.product-low-inventory-label');
            }

            if (hasStandardBadge) {
                searchAndShowElement($uncachedData, '.product-badge-label');
            }
        }
    });
}

module.exports = {
    manageTileBadges: function () {
        manageTileBadges();

        $(document).on('search:showMoreUpdated einstein.slider einstein.slider.cart shoppableContent:ModalLoaded', function () {
            manageTileBadges();
        });
    },
};
